"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'OrderInfo',
  props: {
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableHeight: {
      type: Number,
      default: 400
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    deliveryType: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: false
    },
    commissionErrors: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    getCommissionError: function getCommissionError(row, field) {
      var key = row.id || row.orderSolutionId;
      var errors = this.commissionErrors[key];
      return errors ? errors[field] || '' : '';
    }
  }
};
exports.default = _default2;